import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthLoadingScreen from './AuthLoadingScreen';

/**
 * ProtectedRoute wraps routes that require authentication.
 *
 * - If still loading (initial session check), shows a spinner
 * - If not authenticated + has logged in this session → /login  (known user, just timed out)
 * - If not authenticated + no session flag              → /      (new visitor → landing page)
 * - If authenticated, renders the children
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (!isAuthenticated) {
    const isKnownUser = sessionStorage.getItem('rzHasLoggedIn') === '1';
    return <Navigate to={isKnownUser ? '/login' : '/'} replace />;
  }

  return children;
};

export default ProtectedRoute;
